// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { get } from 'lodash';

import ChoiceList from 'app/common/components/ChoiceList';
import 'app/service/components/AppsSearch/AppsResults.scss';

import { type App } from 'app/service/components/AppsSearch/types';

const bem = bemify('apps-results');

type ResultProps = {
  ...$Exact<App>,
  isSelected: boolean,
};

const AppsResult = ({ name, images, isSelected }: ResultProps) => (
  <div
    className={bem('__apps-search-result', toModifiers({ hover: isSelected }))}
  >
    <img alt={`${name} Icon`} src={images.url_32x32} />
    <span className={bem('__app-name')}>{name}</span>
  </div>
);

type ResultsProps = {
  hoveredItem?: string,
  items: Array<App>,
  onChoose: (value: string, didConfirm: boolean) => void,
};

const AppsResults = ({ hoveredItem, items, onChoose }: ResultsProps) => (
  <div className={bem()}>
    <ChoiceList
      className={bem('__apps-results-list')}
      hoveredItem={hoveredItem}
      Item={AppsResult}
      items={items}
      itemValueKey={'slug'}
      onChoose={onChoose}
      value={hoveredItem || get(items, ['0', 'slug'], '')}
    />
  </div>
);

export default AppsResults;
